import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

// Web project "bite-web" (the mobile app reports to its own project).
const DSN =
  "https://7a9522a633cd6423c38f9b4596d38bcf@o4511919085649920.ingest.us.sentry.io/4512170695720960";

// Only production builds report, so local development doesn't fill the
// project with noise. Set REACT_APP_SENTRY_DEV=true to test from `npm start`.
const enabled =
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_SENTRY_DEV === "true";

Sentry.init({
  dsn: DSN,
  enabled,
  environment: process.env.NODE_ENV,
  // Don't attach IPs, cookies or request bodies; signed-in users are
  // identified by uid only (see src/app/auth/AuthProvider.js).
  sendDefaultPii: false,
  enableLogs: true,
  integrations: [
    // Names transactions after routes ("/app/r/:recipeId"), not raw URLs.
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0.2,
  // Record only sessions that hit an error.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

// Session Replay is ~100 kB, so it's fetched from Sentry's CDN after the page
// has loaded instead of shipping in the landing page bundle. Recordings mask
// all text and block images by default, so recipes, notifications and emails
// never leave the browser.
if (enabled && typeof window !== "undefined") {
  window.addEventListener(
    "load",
    () => {
      Sentry.lazyLoadIntegration("replayIntegration")
        .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
        .catch(() => {
          // Blocked by an ad blocker or offline; errors are still reported.
        });
    },
    { once: true }
  );
}

export default Sentry;
